import { isAxiosError } from "axios"

import axiosInstance from "../api.axiosInstance"
import type {
  BatterySystem,
  EquipmentSyncStatusResponseDto,
  ModuleInverterCompatibilityResponseDto,
  SyncEquipmentResponseDto,
  UpdateModuleInverterEquipmentDto,
  UpdateModuleInverterEquipmentResponseDto,
} from "../dto/equipment-dto"

export class EquipmentService {
  async fetchBatterySystems(): Promise<BatterySystem[]> {
    try {
      const response = await axiosInstance.get<BatterySystem[]>(
        `/equipment/v1/battery-systems`,
      )
      return response.data
    } catch (error: unknown) {
      if (isAxiosError(error) && error.response?.status === 404) {
        throw new Error(`Battery systems not found`)
      }
      throw error
    }
  }

  async getEquipmentSyncStatus(): Promise<EquipmentSyncStatusResponseDto> {
    const response = await axiosInstance.get<EquipmentSyncStatusResponseDto>(
      `/v2/equipment/sync/status`,
    )
    return response.data
  }

  async syncEquipment(): Promise<SyncEquipmentResponseDto> {
    const response =
      await axiosInstance.post<SyncEquipmentResponseDto>(`/v2/equipment/sync`)
    return response.data
  }

  async fetchModuleInverterCompatibility(
    proposalId: string,
  ): Promise<ModuleInverterCompatibilityResponseDto> {
    const response =
      await axiosInstance.get<ModuleInverterCompatibilityResponseDto>(
        `/equipment/v2/proposals/${proposalId}/module-inverter-compatibility`,
      )

    return response.data
  }

  async updateModuleInverterEquipment(
    proposalId: string,
    designId: string,
    payload: UpdateModuleInverterEquipmentDto,
  ): Promise<UpdateModuleInverterEquipmentResponseDto> {
    const response =
      await axiosInstance.put<UpdateModuleInverterEquipmentResponseDto>(
        `/design/v2/proposals/${proposalId}/designs/${designId}/module-inverter-equipment`,
        payload,
      )

    return response.data
  }
}

export const equipmentService = new EquipmentService()
